<template>
	
	<div class="twenty-padding scroll-y has-action-bar" v-loading="$store.getters.loading">
		
		<el-form v-if="settings.id" :model="settings" ref="settingsForm" label-position="top">
			
			<el-row :gutter=24>
				
				<el-col :span=12>
					
					<el-form-item label="Name">
						<el-input v-model="settings.name"></el-input>
					</el-form-item>
					
					<el-form-item label="Description">
						<el-input type="textarea" :rows="4" v-model="settings.description"></el-input>
					</el-form-item>
					
					<el-form-item label="Website">
						<el-input v-model="settings.website"></el-input>
					</el-form-item>
					
					<el-form-item label="Contacts">
						<UsersDropdown v-model="settings.contacts"/>
					</el-form-item>
								
					<el-form-item label="Platforms">
						<el-checkbox v-model="settings.android" label="Android" :true-label="1" :false-label="0"></el-checkbox>
						<el-checkbox v-model="settings.iphone" label="iPhone" :true-label="1" :false-label="0"></el-checkbox>
						<el-checkbox v-model="settings.ipad" label="iPad" :true-label="1" :false-label="0"></el-checkbox>
						<el-checkbox v-model="settings.web" label="Web" :true-label="1" :false-label="0"></el-checkbox>
						<el-checkbox v-model="settings.desktop" label="Desktop" :true-label="1" :false-label="0"></el-checkbox>
					</el-form-item>
					
					<el-form-item label="Billing / Maintenance">
						
						<el-radio-group v-model="settings.billing_settings.type">
							<el-radio label="limited">Limited Hours</el-radio>
							<el-radio label="unlimited">Unlimited Hours</el-radio>
						</el-radio-group>
						
						<el-row v-show="settings.billing_settings.type == 'limited'" :gutter=24>
							<el-col :span=12>
								<el-form-item label="Hourly Rate">
									<el-input-number v-model="settings.billing_settings.rate" controls-position="right" :value="0" :step="25" style="width: 100%;"></el-input-number>
								</el-form-item>
							</el-col>
							<el-col :span=12>
								<el-form-item label="Included Hours Per Month">
									<el-input-number v-model="settings.billing_settings.included_hours" controls-position="right" :value="0" style="width: 100%;"></el-input-number>
								</el-form-item>
							</el-col>
						</el-row>
						
						<el-row v-show="settings.billing_settings.type == 'unlimited'" :gutter=24>
							<el-col :span=12>
								<el-form-item label="Monthly Rate">
									<el-input-number v-model="settings.billing_settings.rate" controls-position="right" :value="0" style="width: 100%;"></el-input-number>
								</el-form-item>
							</el-col>
						</el-row>
						
					</el-form-item>
					
				</el-col>
				
			</el-row>
			
		</el-form>
		
		<ActionBar :actions="actionButtons" @click="onClickActionButton"/>
		
	</div>
	
</template>

<script>
	
	import SettingsBase from "@/components/Base/Settings";
	
	export default {
		
		extends: SettingsBase,
		
		methods: {
			onClickActionButton(actionButton) {
				if (actionButton.name == "save") {
					this.$store.commit("setLoading", { type: "start" });
					this.axios.post(`projects/${this.settings.id}`, {
						project: this.settings,
					}).then((r) => {
						if (r.data.success) {
							this.$store.commit("setLoading", { type: "finish", message: "Your changes have been saved." });
							this.$store.dispatch("refreshSelectedProject", { data: r.data.projects[0] });
							this.dirty = false;
						}
					}).catch((e) => {
						this.$store.commit("setLoading", { type: "error", message: "An unknown error occurred while saving this project." });
					});
				}
			},
		},
		
		mounted() {
			this.$store.dispatch("refreshSelectedProject", {
				slug:  this.$route.params.projectSlug,
				callback: () => {
					this.settings = Object.assign({}, this.$store.getters.project);
					this.$watch("settings", (newValue, oldValue) => {
						this.dirty = true;
					}, { deep: true });
				}
			});
		},
		
	}
	
</script>

<style scoped>
	
	
	
</style>


// WEBPACK FOOTER //
// src/components/Projects/Project/Settings.vue